import { render } from "./AllianceCard.vue?vue&type=template&id=ddb9e156&scoped=true"
import script from "./AllianceCard.vue?vue&type=script&lang=js"
export * from "./AllianceCard.vue?vue&type=script&lang=js"

import "./AllianceCard.vue?vue&type=style&index=0&id=ddb9e156&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb9e156"]])

export default __exports__